<template>
  <div id="CvWizardStepper">
    <CvWizardStepper :stepModel="updateModelByRouteId" />
  </div>
</template>



<script>
import CvWizardStepper from '@/components/CvWizard/CvWizardStepper';
import { WIZARD_CV_DATA } from '@/lib/api.js';
export default {
  layout: 'innerPage',
  components: { CvWizardStepper },
  computed: {
    updateModelByRouteId() {
      return this.$route.params.id;
    },
  },
  async fetch(context) {
    const { data } = await context.$axios(`${WIZARD_CV_DATA}`);

    context.store.commit('INIT_CVW_CONTENT', data);
  },
  head() {
    return {
      title: 'כתיבת קורות חיים מקצועיים בחינם',
    };
  },
};
</script>

